"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { i18n, switchLocalePath, type Locale } from "@/lib/i18n/config";

const LABELS: Record<Locale, string> = { fr: "FR", en: "ENG" };

/**
 * Bascule FR/EN vers la page équivalente : le chemin courant est conservé,
 * seul le préfixe de langue change.
 */
export default function LanguageSwitcher({ locale }: { locale: Locale }) {
  const pathname = usePathname() || "/";

  return (
    <div className="flex items-center rounded-full border border-ink/15 p-1 text-xs font-semibold">
      {i18n.locales.map((code) => {
        const active = code === locale;
        return (
          <Link
            key={code}
            href={switchLocalePath(pathname, code)}
            hrefLang={code}
            aria-current={active ? "true" : undefined}
            className={
              active
                ? "rounded-full bg-ink-deep px-3 py-1.5 text-white"
                : "rounded-full px-3 py-1.5 text-ink/60 transition hover:text-ink"
            }
          >
            {LABELS[code]}
          </Link>
        );
      })}
    </div>
  );
}
